module.exports = __webpack_public_path__ + "img/logo-simple.3560f274.jpg";